export default "@media (max-width: 767px) {}\r\n\r\nbody {\r\n  background-color: #ffffff;\r\n}\r\n";